module.exports = __webpack_public_path__ + "static/media/2017_conf_Product_Centricity.dfca9aa1.png";